import { render, staticRenderFns } from "./PublishingStatisticsCreateNewFavoriteDialog.vue?vue&type=template&id=4846f7cb"
import script from "./PublishingStatisticsCreateNewFavoriteDialog.vue?vue&type=script&lang=js"
export * from "./PublishingStatisticsCreateNewFavoriteDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports